<afoone-breadcrumb [breadcrumbItems]="breadcrumbs"></afoone-breadcrumb>

<div class="patient-request-list">
  <div class="patient-request-patient-header">
    <h4 *ngIf="patient$ | async">{{ "PATIENT_DATA.PATIENT" | translate }}</h4>
    <div *ngIf="isPatientSearch && (hasAnyLabTypeLABC || patientHasMicrobiology)" class="patient-request-actions-row">
      <p-button
        *ngIf="hasAnyLabTypeLABC"
        label="{{ 'ACUMULADOS.TITLE' | translate }}"
        icon="pi pi-list"
        (onClick)="openAcumuladosDialog()"
      ></p-button>
      <p-button
        *ngIf="patientHasMicrobiology"
        label="{{ 'WEB_RESULTS.EPIDEMIOLOGY.BUTTON_FROM_PATIENT_LIST' | translate }}"
        icon="pi pi-chart-line"
        (onClick)="openEpidemiologyDialog()"
      ></p-button>
    </div>
  </div>
  <afoone-patient-data [patient]="patient$ | async"></afoone-patient-data>

  <ng-container *ngIf="records$ | async as records">
    <p-message *ngIf="records.length === 0" severity="error">
      No se encontraron resultados
    </p-message>

    <p-table
      [value]="records"
      *ngIf="records.length > 0"
      styleClass="p-datatable-striped"
      selectionMode="single"
      sortMode="single"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [metaKeySelection]="true"
      [paginator]="true"
      [rows]="5"
      [showCurrentPageReport]="true"
      [(selection)]="selectedRequest"
      currentPageReportTemplate="{first} - {last} {{
        'LIST.OF' | translate
      }} {totalRecords} {{ 'LIST.RECORDS' | translate }}"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let column of columns">
            <ng-container [ngSwitch]="column">
              <th pSortableColumn="einDat" *ngSwitchCase="'eindat'">
                {{ "REQUEST_DATA.EINDAT" | translate }}
                <p-sortIcon field="einDat"></p-sortIcon
                ><p-columnFilter
                  type="date"
                  field="einDat"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="peticion" *ngSwitchCase="'peticion'">
                {{ "REQUEST_DATA.AUFTRNR" | translate }}
                <p-sortIcon field="peticion"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="peticion"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="petCentro" *ngSwitchCase="'petcentro'">
                {{ "REQUEST_DATA.PET_CENTRO" | translate }}
                <p-sortIcon field="petCentro"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="petCentro"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="patVorname" *ngSwitchCase="'patvorname'">
                {{ "PATIENT_DATA.NOMBRE" | translate }}
                <p-sortIcon field="patVorname"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="patVorname"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="patName" *ngSwitchCase="'patname'">
                {{ "PATIENT_DATA.APELLIDOS" | translate }}
                <p-sortIcon field="patName"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="patName"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="estado" *ngSwitchCase="'estado'">
                {{ "REQUEST_DATA.ESTADO" | translate }}
                <p-sortIcon field="estado"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="estado"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="laboratorio" *ngSwitchCase="'laboratorio'">
                {{ "REQUEST_DATA.LABORATORIO" | translate }}
                <p-sortIcon field="laboratorio"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="laboratorio"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="materialName" *ngSwitchCase="'materialname'">
                {{ "REQUEST_DATA.MATERIAL_NAME" | translate }}
                <p-sortIcon field="materialName"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="materialName"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>

              <th pSortableColumn="statName" *ngSwitchCase="'statname'">
                {{ "REQUEST_DATA.STATNAME" | translate }}
                <p-sortIcon field="statName"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="statName"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="notfall" *ngSwitchCase="'notfall'">
                {{ "REQUEST_DATA.NOTFALL" | translate }}
                <p-sortIcon field="notfall"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="notfall"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="alertas" *ngSwitchCase="'alertas'">
                {{ "REQUEST_DATA.ALERTAS" | translate }}
                <p-sortIcon field="alertas"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="alertas"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="ndocs" *ngSwitchCase="'ndocs'">
                {{ "REQUEST_DATA.NDOCS" | translate }}
                <p-sortIcon field="ndocs"></p-sortIcon>
                <p-columnFilter
                  type="numeric"
                  field="ndocs"
                  display="menu"
                  [showOperator]="false"
                  [showAddButton]="false"
                ></p-columnFilter>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr [pSelectableRow]="record" (click)="onRowSelect(record)">
          <ng-container *ngFor="let column of columns">
            <ng-container [ngSwitch]="column">
              <td *ngSwitchCase="'eindat'">
                {{ record.einDat | date : "dd/MM/yyyy HH:mm" : "UTC" }}
              </td>
              <td *ngSwitchCase="'peticion'">{{ record.peticion }}</td>
              <td *ngSwitchCase="'petcentro'">{{ record.petCentro }}</td>
              <td *ngSwitchCase="'patname'">{{ record.patName }}</td>
              <td *ngSwitchCase="'patvorname'">{{ record.patVorname }}</td>
              <td *ngSwitchCase="'estado'">{{ record.estado }}</td>
              <td *ngSwitchCase="'laboratorio'">{{ record.laboratorio }}</td>
              <td *ngSwitchCase="'materialname'">
                {{ record.materialName || record.materialname }}
              </td>
              <td *ngSwitchCase="'statname'">{{ record.statname  || record.statName}}</td>
              <td *ngSwitchCase="'notfall'">{{ (record.notfall ?? record.urgente ?? '') }}</td>
              <td *ngSwitchCase="'alertas'">{{ record.alertas }}</td>
              <td *ngSwitchCase="'ndocs'">{{ record.ndocs }}</td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <div
    #selectedRequestResults
    id="selected-request-results"
    class="selected-request-results"
  >
    <p-table
      [value]="materiales"
      selectionMode="single"
      [metaKeySelection]="true"
      [(selection)]="selectedMaterial"
      *ngIf="materiales && materiales.length > 0"
      styleClass="p-datatable-striped"
      class="materiales-table"
      [paginator]="false"
      dataKey="methname"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="material-name-column">
            {{ "REQUEST_DATA.MATERIAL_NAME" | translate | uppercase }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr
          (click)="onMaterialSelect(record)"
          [ngClass]="{
            clickable: true,
            selected: record?.materialNr === selectedMaterial.materialNr
          }"
        >
          <td>{{ record?.methname }}</td>
        </tr>
      </ng-template>
    </p-table>

    <afoone-patient-request-detail
      [request]="selectedRecord$ | async"
      [patient]="patient$ | async"
    ></afoone-patient-request-detail>
  </div>
</div>
